/* eslint-disable */

import React, { Component } from 'react';
import { compose, graphql, withApollo } from 'react-apollo';
import { Link } from 'react-router-dom';
import gql from 'graphql-tag';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Button, Grid, Popup, Loader } from 'semantic-ui-react';
import CopyToClipboard from 'react-copy-to-clipboard';
import PresentationAds from './PresentationAds';
import update from 'react-addons-update';
import _ from 'lodash';

import * as AppActions from '../../actions';
import { getPresentations } from '../../services/PresentationManager';
import createNewPresentation from '../../utils/presentation';
import './PresentationList.css';

class PresentationList extends Component {
  state = {
    path:
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : ''),
    presentationList: [],
    column: null,
    direction: null,
    showConfirm: false,
    refreshExpiration: null,
    presentationToUpdate: {},
    refreshingExpirationIds: [],
    token: this.props.getFbToken(),
    loading: false
  };

  componentDidMount() {
    this.props.setSectionTitle('Presentations');
    this.props.saveGTMEvent('Presentations', 'Presentations');
    this.getPresentations();
  }

  getPresentations = async () => {
    this.setState({ loading: true });
    const presentations = await getPresentations();
    const presentationsSorted = _.sortBy(
      [...presentations.presentations],
      'created_at'
    ).reverse();
    this.setState({ presentationList: presentationsSorted, loading: false });
  };

  handleSort = (clickedColumn) => () => {
    const { column, presentationList, direction } = this.state;

    if (column !== clickedColumn) {
      this.setState({
        column: clickedColumn,
        presentationList: _.sortBy(presentationList, [clickedColumn]),
        direction: 'ascending'
      });

      return;
    }

    this.setState({
      presentationList: presentationList.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending'
    });
  };

  handlePresentationToggle = (e, { data }) => {
    data.active = data.active ? false : true;
    this.setState({
      flashMessage: data.active
        ? 'Presentation will be updated automatically'
        : 'Presentation will not be updated automatically'
    });
    console.log(this.props);
    this.props.update(data);
  };

  openDialog = (e, { data }) => {
    this.setState({ showConfirm: true, deleteRowId: data.id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  handleConfirm = () => {
    this.setState({ showConfirm: false });
    this.props.delete(this.state.deleteRowId);
    const presentationList = [...this.state.presentationList];
    const removedItem = presentationList.find(
      (presentation) => presentation.id === this.state.deleteRowId
    );
    const index = presentationList.indexOf(removedItem);
    if (index !== -1) {
      presentationList.splice(index, 1);
    }
    this.setState({ flashMessage: 'Presentation Deleted', presentationList });
  };

  onCopy = (text, result) => {
    const urlParts = text.split('/');
    this.setState({ copied: urlParts[urlParts.length - 1] });
    setTimeout(() => {
      this.setState({ copied: null });
    }, 5000);
  };

  mouseEnter = (e) => {
    const id = parseInt(e.target.id);
    this.setState({ refreshExpiration: id });
  };

  mouseLeave = () => {
    this.setState({ refreshExpiration: null });
  };

  updateExpiration = async (presentation) => {
    this.setState({
      refreshingExpirationIds: [
        ...this.state.refreshingExpirationIds,
        presentation.id
      ]
    });
    const name = presentation.name;
    await this.getPresentation(name);
    const newPresentation = createNewPresentation(
      this.state.presentationToUpdate
    );

    let expirationDate = new Date(newPresentation.expiredAt);
    let today = new Date();

    if (expirationDate <= today) {
      today.setDate(today.getDate() + 7);
      expirationDate = today;
    } else {
      let todayPlusMonth = new Date();
      todayPlusMonth.setDate(today.getDate() + 30);
      expirationDate.setDate(expirationDate.getDate() + 7);

      if (expirationDate > todayPlusMonth) {
        expirationDate = todayPlusMonth;
      }
    }
    newPresentation.expiredAt = expirationDate.toISOString().split('T')[0];
    let presentationUpdated = this.state.presentationList.find(
      (p) => p.id === presentation.id
    );
    presentationUpdated.expired_at = expirationDate.toISOString().split('T')[0];
    await this.props.update(newPresentation);
    let ids = this.state.refreshingExpirationIds;
    ids.splice(ids.indexOf(presentation.id), 1);
    this.setState({
      refreshingExpirationIds: ids
    });
  };

  getPresentation = async (name) => {
    const presentationByNameQuery = {
      query: gql`
        query {
        presentationByName(name: "${name}") {
          id
          name
          url
          data
          cachedquery
          username
          active
          createdAt
          updatedAt
          expiredAt
        }
      }`
    };

    await this.props.client.query(presentationByNameQuery).then((response) => {
      this.setState({ presentationToUpdate: response.data.presentationByName });
    });
  };

  expireTooltip = (expiration) => {
    let message = "Add 7 days to expiration. You can't add more than 30 days";

    let expirationDate = new Date(expiration);
    expirationDate.setDate(expirationDate.getDate() + 1);

    let today = new Date();
    today.setDate(today.getDate() + 30);

    const diffDays =
      parseInt((today - expirationDate) / (1000 * 60 * 60 * 24)) + 1;

    if (expirationDate.getDate() === today.getDate() || diffDays < 0) {
      message = "You can't add more than 30 days";
    } else if (diffDays < 7) {
      message = 'Add ' + diffDays + ' days to expiration';
    }

    return message;
  };

  isUpdateExpirationEnabled = (expiration) => {
    const expiredAt = new Date(expiration);
    expiredAt.setDate(expiredAt.getDate() + 1);

    let today = new Date();
    today.setDate(today.getDate() - 1);

    let monthFromToday = new Date();
    monthFromToday.setDate(monthFromToday.getDate() + 30);

    const diffDays =
      parseInt((monthFromToday - expiredAt) / (1000 * 60 * 60 * 24)) + 1;

    return expiredAt.getDate() !== today.getDate() && diffDays > 0;
  };

  renderPresentations = () => {
    const { presentationList, direction, column } = this.state;
    return (
      <div>
        <Grid>
          <Grid.Row columns={3}>
            <Grid.Column>{this.state.flashMessage}</Grid.Column>
            <Grid.Column />
          </Grid.Row>
        </Grid>
        <Table sortable celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={column === 'name' ? direction : 'descending'}
                onClick={this.handleSort('name')}
              >
                Name
              </Table.HeaderCell>
              <Table.HeaderCell>Created By</Table.HeaderCell>
              <Table.HeaderCell
                sorted={column === 'created_at' ? direction : 'descending'}
                onClick={this.handleSort('created_at')}
              >
                Created At
              </Table.HeaderCell>
              <Table.HeaderCell className="col-expiration">
                Expiration
              </Table.HeaderCell>
              <Table.HeaderCell>
                <div className="div-confirm">
                  Delete
                  <Popup
                    trigger={<i className="info circle icon" />}
                    content="This will invalidate this link for all clients its been shared with"
                  />
                </div>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {presentationList.slice(0, 500).map((presentation) => {
              const cachedQuery = JSON.parse(presentation.cachedquery);
              let title = presentation.name;
              title = title.replace('CUSTOM - ', '');
              const arr = title.split(' ');
              title = arr[0].replace(/[0-9]/g, '');
              return (
                <Table.Row key={presentation.id}>
                  <Table.Cell className="row-size">
                    <CopyToClipboard
                      text={`${this.state.path}/presentations/detail/${presentation.url}`}
                      onCopy={this.onCopy}
                    >
                      <a className="link-presentation">
                        {presentation.name
                          .replace(arr[0], title)
                          .replace('CUSTOM - ', '')}
                        {cachedQuery.is_custom_ads ? (
                          <Popup
                            trigger={<b className="custom-text"> Custom</b>}
                            content={
                              <div>
                                <PresentationAds
                                  data={{
                                    ads: cachedQuery.ads_ids.LINK_CLICKS,
                                    title: 'Traffic'
                                  }}
                                />
                                <PresentationAds
                                  data={{
                                    ads: cachedQuery.ads_ids.LEAD_GENERATION,
                                    title: 'Lead Generation'
                                  }}
                                />
                                <PresentationAds
                                  data={{
                                    ads: cachedQuery.ads_ids.VIDEO_VIEWS,
                                    title: 'Video Views'
                                  }}
                                />
                                <PresentationAds
                                  data={{
                                    ads:
                                      cachedQuery.ads_ids.PRODUCT_CATALOG_SALES,
                                    title: 'Product Catalog Sales'
                                  }}
                                />
                                <PresentationAds
                                  data={{
                                    ads: cachedQuery.ads_ids.CONVERSIONS,
                                    title: 'Conversions'
                                  }}
                                />
                                <PresentationAds
                                  data={{
                                    ads: cachedQuery.ads_ids.MESSAGES,
                                    title: 'Messenger Ads'
                                  }}
                                />
                              </div>
                            }
                          />
                        ) : null}
                      </a>
                    </CopyToClipboard>
                    {this.state.copied === presentation.url ? (
                      <div className="div-expires">
                        <span>Copied</span>
                      </div>
                    ) : null}
                  </Table.Cell>
                  <Table.Cell>{presentation.username}</Table.Cell>
                  <Table.Cell>
                    {new Date(
                      Date.parse(presentation.created_at)
                    ).toLocaleString('en-us', {
                      month: 'long',
                      day: '2-digit',
                      year: 'numeric',
                      hour: 'numeric',
                      minute: 'numeric'
                    })}
                  </Table.Cell>
                  <Table.Cell
                    className="expired-td"
                    id={presentation.id}
                    onMouseEnter={this.mouseEnter}
                    onMouseLeave={this.mouseLeave}
                  >
                    <div className="expired-wrapper">
                      {presentation.expired_at}
                      {this.state.refreshExpiration === presentation.id &&
                      !this.state.refreshingExpirationIds.includes(
                        presentation.id
                      ) ? (
                        <div className="text-expires-update">
                          {this.isUpdateExpirationEnabled(
                            presentation.expired_at
                          ) ? (
                            <Popup
                              trigger={
                                <i
                                  className="refresh icon"
                                  onClick={() =>
                                    this.updateExpiration(presentation)
                                  }
                                />
                              }
                              content={this.expireTooltip(
                                presentation.expired_at
                              )}
                            />
                          ) : (
                            <Popup
                              trigger={<i className="refresh icon greyed" />}
                              content={this.expireTooltip(
                                presentation.expired_at
                              )}
                            />
                          )}
                        </div>
                      ) : null}
                      {this.state.refreshingExpirationIds.includes(
                        presentation.id
                      ) ? (
                        <div className="spinner-expires">
                          <Loader inline className="active" size="mini" />
                        </div>
                      ) : null}
                    </div>
                  </Table.Cell>
                  <Table.Cell className="col-confirm">
                    {this.state.showConfirm &&
                    presentation.id === this.state.deleteRowId ? (
                      <div className="div-confirm">
                        <p className="text-confirm">Are you sure?</p>
                        <Button
                          onClick={this.handleConfirm}
                          size="mini"
                          color="grey"
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={this.handleCancel}
                          size="mini"
                          color="red"
                        >
                          No
                        </Button>
                      </div>
                    ) : (
                      <div className="div-confirm">
                        <Button
                          data={{ id: presentation.id }}
                          onClick={this.openDialog}
                          size="small"
                          color="blue"
                        >
                          Delete
                        </Button>
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
        {this.state.loading ? (
          <div className="presentation-list-loading">
            <Loader inline active /> Loading...
          </div>
        ) : null}
      </div>
    );
  };

  render() {
    return <div className="container">{this.renderPresentations()}</div>;
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

const updateQuery = gql`
  mutation($id: Int!, $presentation: PresentationPatch!) {
    updatePresentationById(
      input: { id: $id, presentationPatch: $presentation }
    ) {
      presentation {
        id
        url
        username
        createdAt
        updatedAt
        cachedquery
        active
        name
        expiredAt
      }
    }
  }
`;

const deleteQuery = gql`
  mutation($id: Int!) {
    deletePresentationById(input: { id: $id }) {
      presentation {
        id
        url
        username
        createdAt
        updatedAt
        active
        name
      }
    }
  }
`;

const withPresentationList = compose(
  graphql(deleteQuery, {
    props: ({ mutate }) => ({
      delete: (id) =>
        mutate({
          variables: { id }
        })
    })
  }),
  graphql(updateQuery, {
    props: ({ mutate }) => ({
      update: (presentation) =>
        mutate({
          variables: {
            id: presentation.id,
            presentation: _.omit(presentation, [
              'id',
              'url',
              'data',
              'username',
              'cachedquery',
              'createdAt',
              'name',
              '__typename'
            ])
          }
        })
    })
  })
);
const ListWithData = withPresentationList(PresentationList);

export default withApollo(
  connect(mapStateToProps, mapDispatchToProps)(ListWithData)
);



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationList.js